import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { NgxSmartModalService } from "ngx-smart-modal";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { PaymentService } from "../../services/payment.service";
import { UserService } from "../../services/user.service";
import { SubscriptionModel } from "../../models/team.model";
import { Subscription } from "rxjs";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { STORE_LINKS } from '../../constants/store-links';

@Component({
  selector: 'app-team-subscription',
  templateUrl: './team-subscription.component.html',
  styleUrl: './team-subscription.component.scss'
})
export class TeamSubscriptionComponent implements OnInit, OnDestroy {
  private _ngxSmartModalService: NgxSmartModalService = inject(NgxSmartModalService);
  private _router: Router = inject(Router);
  private _translateService: TranslateService = inject(TranslateService);
  private _paymentService: PaymentService = inject(PaymentService);
  private _userService: UserService = inject(UserService);
  private _platformId = inject(PLATFORM_ID);
  private _document = inject(DOCUMENT);

  @Input() userData!: any;
  @Input() set subscriptionData(subscription: any) {
    if (subscription !== undefined) {
      this.subscription = subscription;
      this.subscriptionLoaded = true;
    }
  }
  @Output() getProjectEmit: EventEmitter<void> = new EventEmitter<void>;
  loadingPaymentProcess: boolean = false;
  showOtp: boolean = false;
  paymentProcessError: boolean = false;
  subscription!: SubscriptionModel;
  subscriptionLoaded: boolean = false;
  termsAccepted: boolean = false;
  userSub!: Subscription;

  TOTAL = 699;
  private static readonly VAT_RATE = 0.25; // 25% Norway

  readonly discount: string = '0.00';
  readonly total: string = String(this.TOTAL);
  readonly amount: string = (this.TOTAL / (1 + TeamSubscriptionComponent.VAT_RATE)).toFixed(2); // net
  readonly vat: string = (this.TOTAL - Number(this.amount)).toFixed(2);
  readonly storeLinks = STORE_LINKS;

  constructor() {
  }

  ngOnInit(): void {
    this.userDataSubscription(); // TODO need unsubscribe
  }

  userDataSubscription(): void {
    this.userSub = this._userService.user$.subscribe((loginData: any | '') => {
      // this.loginData = userData;
      this.userData = null;

      if (loginData && loginData.user) {
        this.userData = loginData.user;
      }

      // this.isSchool = this.userData ? this.userData.profile.school : false; // TODO probably need remove it
    });
  }

  runPaymentProcess(): void {
    this.loadingPaymentProcess = true;
    this.paymentProcessError = false;

    this._paymentService.createSubscription().subscribe((res: unknown) => {
      this.getSubscriptionInvoice();
    }, error => {
      console.log('error', error);
      if (error.error.detail.includes("already have a subscription")) {
        this.getSubscriptionInvoice();
      } else {
        this.loadingPaymentProcess = false;
        this.paymentProcessError = true;
      }
    })
  }

  getSubscriptionInvoice(): void {
    this._paymentService.createInvoice().subscribe((res: any) =>{
      this.createSession(res.id);
    }, error => {
      if (error.error.detail.includes("already has pending invoice")) {
        this.getInvoices();
      } else {
        this.loadingPaymentProcess = false;
        this.paymentProcessError = true;
      }
    });
  }

  getInvoices(): void {
    this._paymentService.getInvoices().subscribe((res: any) => {
      this.findLastUnpaidInvoice(res.results);
    }, error => {
      this.loadingPaymentProcess = false;
      this.paymentProcessError = true;
    });
  }

  findLastUnpaidInvoice(invoices: any): void {
    if (!invoices || invoices.length === 0) {
      console.error('findLastUnpaidInvoice#error: No invoices in list');
      return;
    }

    const unpaidInvoices = invoices.filter((inv: any) => inv.payment_status === 'PENDING');

    if (unpaidInvoices.length === 0) {
      console.error('findLastUnpaidInvoice#error: No "PENDING" invoices in list');
      return;
    }

    const lastUnpaidInvoice = unpaidInvoices.reduce((prev: any, current: any) => {
      return (prev.id > current.id) ? prev : current;
    });

    this.createSession(lastUnpaidInvoice.id);
  }

  createSession(invoiceId: number): void {
    const id: string = invoiceId.toString();
    this._paymentService.payInvoice(id).subscribe((res: any) =>{
      const redirectUrl: string = res.hostedPaymentPageUrl;
      // window.location.href = redirectUrl;
      if (isPlatformBrowser(this._platformId)) {
        this._document.defaultView?.location.replace(redirectUrl);
      } else {
        console.error('createSession#error isPlatformBrowser: ', redirectUrl)
      }
      this.loadingPaymentProcess = false;
    }, error => {
      this.loadingPaymentProcess = false;
      this.paymentProcessError = true;
    })
  }

  // createSession(invoiceId: number): void {
  //   this.loadingPaymentProcess = true;
  //
  //   this._paymentService
  //     .payInvoice(String(invoiceId))
  //     .pipe(finalize(() => (this.loadingPaymentProcess = false)))
  //     .subscribe({
  //       next: (res: { hostedPaymentPageUrl: string }) => {
  //         const redirectUrl = res.hostedPaymentPageUrl;
  //
  //         if (isPlatformBrowser(this._platformId)) {
  //           this._document.defaultView?.location.replace(redirectUrl);
  //         } else {
  //           console.error('createSession#error redirectUrl: ', redirectUrl)
  //         }
  //       },
  //       error: () => {
  //         this.paymentProcessError = true;
  //       },
  //     });
  // }

  openOtpModal(): void {
    this._ngxSmartModalService.getModal('otpModal').open();
  }

  closeOtp(): void {
    this._ngxSmartModalService.getModal('otpModal').close();
  }

  goToTermsConditions(): void {
    const currentLang: string = this._translateService.currentLang;
    const url = `/${currentLang}/henter-pant/terms-and-conditions`;
    window.open(url, '_blank');
  }

  goToPrivacyPolicy(): void {
    const currentLang: string = this._translateService.currentLang;
    const url = `/${currentLang}/henter-pant/privacy-policy`;
    window.open(url, '_blank');
  }

  getProject(): void {
    this.getProjectEmit.emit();
  }

  ngOnDestroy(): void {
    if (this.userSub) this.userSub.unsubscribe();
  }
}
